import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Loading } from 'src/app/Class/Loading';
import { Subject } from 'rxjs';
import { DTConfig } from 'src/app/Class/DTConfig ';
import { DataTableDirective } from 'angular-datatables';
import { DocumentosService } from 'src/app/servicios/documentos.service';
import { ActivatedRoute } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-versiones-documento',
  templateUrl: './versiones-documento.component.html',
  styleUrls: ['./versiones-documento.component.css']
})
export class VersionesDocumentoComponent implements OnInit, OnDestroy {

  public dtTrigger: Subject<any> = new Subject();
  public dtOptions: DataTables.Settings = Object.assign({}, DTConfig.dtConf);
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  public documentos: any = [];
  public archivo: string = null;
  public url: string = null;
  public id: any;
  public documento: any = {
    palabras_clave: [],
    estamentos: [],
    entidades: [],
    facultades: [],
    normas: [],
    programas: [],
    unidades: [],
    };

  constructor( private documentoService: DocumentosService, public loading: Loading, private rout: ActivatedRoute, ) {
    this.loading.estado = true;
    this.url = this.documentoService.getServe();

    this.rout.params.subscribe(parametros => { this.id = parametros['id']; });

    this.documentoService.getVersiones(this.id).subscribe(data => {
      this.documentos = data['listado'];
      this.initDtOptions();
      this.dtTrigger.next();
      this.loading.estado = false;
      },
      err => {  this.loading.estado = false; }
      );
    }


  ngOnInit() {}

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  verDetalle( datos ) {
    this.archivo =  datos['ruta'] ? this.url +  datos['ruta'] : null;
    this.documento = datos;
    $('#ModalDetalle').modal({ backdrop: 'static', keyboard: true, show: true });
   }

  initDtOptions() {
    this.dtOptions.ordering = false;
  }

}
